import { postBackApi } from './call';

export const postStart = async (invited_by: number | undefined) => {
  return postBackApi(`start?invited_by=${invited_by || ''}`, invited_by ? { invited_by } : undefined).then(
    (response) => response.data
  );
};
